import React, { Fragment } from "react"
import Img from 'gatsby-image'

const DiagnosticLibrary = ({ data }) => {
    const {
        image,
        title,
        headerContent,
        docButtons,
        footerContent,
        subcontent
    } = data

    return (
        <Fragment>
            <section className="diagnostic-library">
                <div className="image-wrapper">
                    {image && (
                        <Img 
                            fluid={image?.localFile?.childImageSharp?.fluid}
                        />
                    )}
                </div>
                <div className="content-wrapper">
                    {title && (
                        <h3>{title}</h3>
                    )}
                    {headerContent && (
                        <div dangerouslySetInnerHTML={{ __html: headerContent }}></div>
                    )}
                    <div className="diagnosis-grid">
                        {docButtons ? docButtons.map((button, i) => {
                            return (
                                <a key={i} className="btn button-outline-dark" href={button.file.localFile.publicURL} target="_blank">{button.title}</a>
                            )
                        }) : null }
                    </div>
                    {footerContent && (
                        <div dangerouslySetInnerHTML={{ __html: footerContent }}></div>
                    )}
                    {subcontent ? subcontent.map((content, i) => {
                        return (
                            <div key={i} className="sub-content">
                                <p className="head">{content.title}</p>
                                <div dangerouslySetInnerHTML={{ __html: content.content }}></div>
                            </div>
                        )
                    }) : null }
                </div>
            </section>
        </Fragment>   
    )
}

export default DiagnosticLibrary
